import {Component, OnInit} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';

@Component({
  selector: 'pm-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  pageTitle: string = 'File Transfer management';
  userDetails: any;
  userRole: any;

  constructor(private _http: HttpClient) {
  }

  LogOut() {
    const postApi = window.location.origin + '/ftportal/logout';
    const params = new HttpParams();
    this._http.post(postApi, {params: params})
      .subscribe(
        res => {
        },
        err => {
          if (err.status === 202) {
            window.location.href = window.location.origin + '/ftportal/ui';
          }
        }
      );
  }

  ngOnInit() {
    const getApi = window.location.origin + '/ftportal/user-info';
    const params = new HttpParams();
    this._http.get(getApi, {params: params})
      .subscribe(userDetails => {
          this.userDetails = userDetails;
          this.userRole = this.userDetails.authorities[0];
        },
        err => {
        }
      );
  }
}
